import { prismicClient } from "@jog/shared";
export const fetchMarket = (uid, previewData) => prismicClient({ previewData }).getByUID("marketing_content", uid);
